import styled from 'styled-components';

/** Mesmo padrão visual de borracharia_major StockMovement/New (DescriptionTextarea) */
export const FieldWrap = styled.div`
  width: 100%;
`;

export const Label = styled.label`
  display: block;
  color: #b0b0b0;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;

  @media (min-width: 768px) {
    font-size: 15px;
  }
`;

export const TextareaField = styled.textarea`
  width: 100%;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  font-family: 'Nunito', Helvetica, sans-serif;
  resize: vertical;
  min-height: 100px;
  transition: all 0.3s ease;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 10px 14px;
    border-radius: 10px;
    font-size: 15px;
    min-height: 120px;
  }

  @media (min-width: 992px) {
    padding: 12px 16px;
    border-radius: 10px;
    font-size: 16px;
    min-height: 140px;
  }

  &:focus {
    outline: none;
    background: rgba(255, 255, 255, 0.08);
    border-color: #00d4ff;
    box-shadow: 0 0 0 3px rgba(0, 212, 255, 0.1);
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
`;

export const ErrorText = styled.span`
  color: #ff6b6b;
  font-size: 12px;
  margin-top: 6px;
  display: block;
`;
